
import { defineComponent } from 'vue'

import ActiveUserMixin, { DashboardContext } from '~/mixins/activeUserMixin'
import OwnerDetailMixin from '~/mixins/ownerDetailMixin'
import PlanDetailMixin from '~/mixins/planDetailMixin'
import { PERSONAL_TO_TEAM_DOCS_URL } from '~/utils/billing'

export default defineComponent({
  name: 'UpgradeAccountModal',
  mixins: [ActiveUserMixin, OwnerDetailMixin, PlanDetailMixin],
  props: {
    login: {
      type: String,
      required: true
    },
    provider: {
      type: String,
      required: true
    }
  },
  async fetch(): Promise<void> {
    const params = {
      login: this.login,
      provider: this.provider
    }

    const queries = [this.fetchBillingDetails(params), this.fetchUsageDetails(params)]

    if (!this.context.plans) {
      queries.push(this.fetchContext())
    }

    await Promise.all(queries)
  },

  computed: {
    maxFeatureUsage(): number | undefined {
      return this.owner.featureUsage?.find(
        ({ shortcode }: Record<string, unknown>) => shortcode === 'autofix'
      )?.max
    },
    isPersonalAccount(): boolean {
      const context = this.activeDashboardContext as DashboardContext
      return context?.type === 'user'
    },
    personalToTeamDocsUrl(): string {
      return PERSONAL_TO_TEAM_DOCS_URL
    },
    bodyText(): string {
      return `You have exhausted the quota of ${this.maxFeatureUsage || ''} Autofix runs included in your current plan for this billing cycle. Consider upgrading your account to keep things running.`
    }
  }
})
